export default {
    LEARN: {
        name: "Apprentissage",
        value: "LEARN"
    },
    UNPAID: {
        name: "Bénévole",
        value: "UNPAID"
    },
    CEE: {
        name: "CEE",
        value: "CEE"
    },
    CDD: {
        name: "CDD PEC",
        value: "CDD"
    },
    CDI: {
        name: "CDI",
        value: "CDI"
    },
    OTHER: {
        name: "Autre",
        value: "OTHER"
    }
};